const state = {
  // Current language of UI
  language: '',

  // Supported languages
  languages: [
    { code: 'EN', text: 'English' },
    { code: 'RU', text: 'Русский' }
  ],

  // MessageInput.vue
  enterMessageText: {
    'EN': 'Enter message...',
    'RU': 'Введите сообщение...'
  },

  // LoginForm.vue
  enterUsernameText: {
    'EN': 'Enter username',
    'RU': 'Введите имя'
  },
  loginButtonText: {
    'EN': 'Join',
    'RU': 'Присоединиться'
  },
  usernameErrorText: {
    'EN': [
      'Username must be between 3 and 16 characters in length',
      'Allowed only alphanumeric characters and underscores',
      'The first symbol is character'
    ],
    'RU': [
      'Имя пользователя должно быть длиной от 3 до 16 символов',
      'Можно использовать числа, буквы и символы подчеркивания',
      'Первый символ - буква'
    ]
  },

  // Settings.vue
  usernameColorPickerText: {
    'EN': 'Username color',
    'RU': 'Цвет имени пользователя'
  },
  languageSelectText: {
    'EN': 'Language',
    'RU': 'Язык'
  },
  showMessageTimeCheckboxText: {
    'EN': 'Show timestamps',
    'RU': 'Показывать время'
  },
  logoutButtonText: {
    'EN': 'Logout',
    'RU': 'Выйти'
  },
  clearMessagesButtonText: {
    'EN': 'Clear messages',
    'RU': 'Очистить сообщения'
  },

  // Errors from backend
  backendErrorText: {
    'username is invalid': {
      'EN': 'Username is incorrect',
      'RU': 'Некорректное имя пользователя'
    },
    'user already exists': {
      'EN': 'User already exists',
      'RU': 'Пользователь уже существует'
    },
    'room is invalid': {
      'EN': 'Room name is invalid',
      'RU': 'Некорректное название комнаты'
    },
    'room is empty': {
      'EN': 'Room name is empty',
      'RU': 'Отсутствует название комнаты'
    },
    'user is empty': {
      'EN': 'Username is empty',
      'RU': 'Отсутствует имя пользователя'
    },
    'you are sending messages too quickly': {
      'EN': 'You are sending messages too quickly',
      'RU': 'Вы слишком часто отправляете сообщения'
    },
    'you are sending equal messages': {
      'EN': 'You are sending equal messages',
      'RU': 'Вы отправляете одинаковые сообщения'
    }
  }
}

const getters = {
  language: state => state.language,
  languages: state => state.languages,

  enterMessageText: state => state.enterMessageText[state.language],

  enterUsernameText: state => state.enterUsernameText[state.language],
  loginButtonText: state => state.loginButtonText[state.language],
  usernameErrorText: state => state.usernameErrorText[state.language],

  usernameColorPickerText: state => state.usernameColorPickerText[state.language],
  languageSelectText: state => state.languageSelectText[state.language],
  showMessageTimeCheckboxText: state => state.showMessageTimeCheckboxText[state.language],
  logoutButtonText: state => state.logoutButtonText[state.language],
  clearMessagesButtonText: state => state.clearMessagesButtonText[state.language],

  backendErrorText (state) {
    return errorText => {
      try {
        return state.backendErrorText[errorText][state.language]
      } catch (err) {
        return errorText
      }
    }
  }
}

const actions = { }

const mutations = {
  setLanguage (state, { language }) {
    state.language = language
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js